import Reveal from "./Reveal";
import { projects } from "../data";

export default function Ecosystem() {
  return (
    <section id="projects" className="py-24 md:py-32 bg-white border-y border-line">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-2xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-accent mb-5">
            Our Ecosystem
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-primary leading-[1.05]">
            Our Business Ecosystem
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-muted">
            Each project responds to a clear market need: transportation, delivery, financial
            access, healthcare support and commercial expansion.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
          {projects.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={i * 0.06} className={p.span}>
                <div
                  data-testid={`project-card-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`group relative h-full overflow-hidden border border-line p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-primary/30 ${
                    p.feature ? "bg-primary text-white" : "bg-surface"
                  }`}
                >
                  <div
                    className={`inline-flex h-12 w-12 items-center justify-center ${
                      p.feature ? "obled-gradient text-white" : "bg-primary/5 text-primary"
                    }`}
                  >
                    <Icon size={24} aria-hidden="true" />
                  </div>
                  <h3
                    className={`mt-6 text-2xl font-display font-medium ${
                      p.feature ? "text-white" : "text-primary"
                    }`}
                  >
                    {p.title}
                  </h3>
                  <p
                    className={`mt-3 leading-relaxed ${
                      p.feature ? "text-white/80" : "text-muted"
                    }`}
                  >
                    {p.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
